import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import VideoManagementDashboardV2 from '@/components/videos/VideoManagementDashboardV2';

const HiveShareManagement: React.FC = () => {
  const { organizationId } = useAuth();
  
  if (!organizationId) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">Loading organization data...</p>
      </div>
    );
  }

  return <VideoManagementDashboardV2 organizationId={organizationId} />;
};

export default HiveShareManagement;